import { cn } from "../lib/cn";

const WEEK_BARS = Array.from({ length: 28 }, (_, index) => ({
  id: `bar-${index}`,
  h: 58 + ((index * 17) % 34),
}));

export function SummaryCardSkeleton({ className }: { className?: string }) {
  return (
    <article
      aria-hidden="true"
      className={cn(
        "relative overflow-hidden rounded-2xl border border-mist-dark/40 bg-white bg-gradient-card p-5 shadow-card lg:p-6",
        "skeleton-sheen",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-wrap items-center gap-3">
          <div className="h-[10px] w-[170px] rounded-full bg-gray-200" />
          <div className="h-[22px] w-[118px] rounded-full bg-gray-100" />
        </div>
        <div className="hidden h-[8px] w-[28px] rounded-full bg-gray-200 sm:block" />
      </div>

      <div className="mt-4 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(300px,440px)] lg:items-end">
        <div className="space-y-2">
          <div className="h-[30px] w-[76%] rounded-md bg-gray-200" />
          <div className="h-[12px] w-[68%] rounded-full bg-gray-100" />
          <div className="h-[12px] w-[44%] rounded-full bg-gray-100" />
        </div>
        <div className="min-w-0">
          <div className="mb-2.5 flex items-end justify-between gap-5">
            <div className="h-[25px] w-[82px] rounded-md bg-gray-200" />
            <div className="hidden h-[10px] w-[178px] rounded-full bg-gray-100 sm:block" />
          </div>
          <div className="flex h-[38px] items-end gap-0.5">
            {WEEK_BARS.map((bar) => (
              <div
                key={bar.id}
                className="flex-1 rounded-[2px] bg-gray-100"
                style={{ height: `${bar.h}%` }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between border-border-subtle border-t pt-3">
        <div className="h-[9px] w-[195px] rounded-full bg-gray-100" />
        <div className="hidden h-[9px] w-[52px] rounded-full bg-gray-100 sm:block" />
      </div>
    </article>
  );
}
